import { CONSTANTS__client } from '@/constants/CONSTANTS__client';
import { CONSTANTS__environment_client } from '@/constants/CONSTANTS__environment_client';
import { assert_is_null } from '@shared/asserts/utils_asserts';
import { ELoggerNamespaceShared } from '@shared/logger/e_logger_namespace_shared';
import { DTO_RESPONSE__error } from '@shared/network/DTO_RESPONSE__error';
import { logi } from '@shared/utils/utils_logs';
import { Socket, io } from 'socket.io-client';
import { ENUM__connection_state } from '../../enums/ENUM__connection_state';
import { local_network_set_state } from '../../state/network/local_network_set_state';
import { store } from '../../state/store';
import { add_socket_handlers_client_all } from './_methods/add_socket_handlers_client_all';
import { SOCKETIO_MIDDLEWARE__emit } from './_middlewares/SOCKETIO_MIDDLEWARE__emit';
import { SOCKETIO_MIDDLEWARE__on } from './_middlewares/SOCKETIO_MIDDLEWARE__on';
import { TimeEntry } from './time_entry';

class ServiceSocketioClient {
  socket: Socket | null = null;

  public events_map = new Set<string>();

  public is_connection_authorized: boolean = false;

  public errors: DTO_RESPONSE__error[] = [];

  public RESPONSE_TIMES: TimeEntry[] = [];

  public outcoming_requests_number: number = 0;

  /*
   * EVENTS
   */

  on_disconnected() {
    if (!this.socket) return;

    this.socket.disconnect();
    this.socket = null;
    this.is_connection_authorized = false;
    this.events_map = new Set<string>();

    CONSTANTS__client.LOGGER_CONNECTION_ID = '';
  }

  /*
   * METHODS
   */

  connect(): void {
    assert_is_null(this.socket, { context: 'socket' });

    store.dispatch(local_network_set_state(ENUM__connection_state.CONNECTING));

    logi(`🔌 connect to\t\t\t${CONSTANTS__environment_client.VITE_SERVICE_ULTIMATEDIFFUSION_SOCKET_URL}`, {
      namespace: ELoggerNamespaceShared.CLIENT_TO_SERVER,
    });

    this.socket = io(CONSTANTS__environment_client.VITE_SERVICE_ULTIMATEDIFFUSION_SOCKET_URL, {
      transports: ['websocket'],
      autoConnect: true,
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 1000,
      timeout: CONSTANTS__environment_client.VITE_SERVICE_ULTIMATEDIFFUSION_SOCKET_CONNECTION_TIMEOUT_NUMBER,
    });

    CONSTANTS__client.LOGGER_CONNECTION_ID = this.socket.id || '';

    SOCKETIO_MIDDLEWARE__on(this.socket);
    SOCKETIO_MIDDLEWARE__emit(this.socket);

    add_socket_handlers_client_all(this.socket);
  }

  disconnect(): void {
    this.on_disconnected();

    store.dispatch(local_network_set_state(ENUM__connection_state.DISCONNECTED));
  }

  getSocket(): Socket | null {
    return this.socket;
  }
}

export const service_socketio_client = new ServiceSocketioClient();
